import React from 'react'
import { SkyInformationPopover } from './SkyPopover'

export const CoverageTypePopover = (props) => {
  return (
    <SkyInformationPopover eventId={'coverage-type'}>
      <div className="text-small bold">Combined Coverage includes:</div>
      <div className="text-small margin-top-small">
        Hull, Spares, Third Party Liability, Hull War, War Liability, Invasion
        of Privacy,
      </div>
      <div className="text-small margin-top-small">
        Noise Liability, Operators Indemnity, Operators Liability and Cyber
      </div>
    </SkyInformationPopover>
  )
}
